/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
class SSEManager {
  constructor() {
    this.eventSource = null
    this.listeners = []
    this.channel = new BroadcastChannel('sse-channel')

    this.channel.onmessage = (event) => {
      this.listeners.forEach((callback) => callback(event.data))
    }
  }

  startSSE(url) {
    if (this.eventSource) return // Avoid multiple connections
    this.eventSource = new EventSource(url)

    this.eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data)
      this.listeners.forEach((callback) => callback(data))

      // Share data with other tabs
      this.channel.postMessage(data)
    }

    this.eventSource.onerror = () => {
      console.error('SSE connection error')
      this.stopSSE()
    }
  }

  stopSSE() {
    if (this.eventSource) {
      this.eventSource.close()
      this.eventSource = null
    }
  }

  subscribe(callback) {
    this.listeners.push(callback)
  }

  unsubscribe(callback) {
    this.listeners = this.listeners.filter((cb) => cb !== callback)
  }
}

const sseManager = new SSEManager()
export default sseManager
